module.exports = __webpack_public_path__ + "static/img/paymentlink.7e88f9b.png";


//////////////////
// WEBPACK FOOTER
// /src/assets/img/screens/paymentlink.png
// module id = Jq3b
// module chunks = 1